var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Spinner from '@fandom-frontend/react-common/dist/components/Spinner';
import GenericModal, { ModalCloseButtonPlacement } from 'pathfinder/modules/shared/GenericModal/GenericModal';
import QuizConsumption from 'pathfinder/modules/shared/QuizConsumption';
import React, { Suspense } from 'react';
import { css } from 'styled-components';
import QuizModalCloseButton from 'pathfinder/modules/QuizConsumptionModule/shared/QuizModalCloseButton';
import { resetQuiz } from 'pathfinder/store/quizConsumptionSlice';
import store from 'pathfinder/store/store';
var overrideModalCSS = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\talign-items: center;\n\tbackground-color: transparent;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tposition: relative;\n\tpadding: 0.01px;\n\tflex-direction: column;\n\twidth: fit-content !important;\n\tmargin: 0 auto;\n"], ["\n\talign-items: center;\n\tbackground-color: transparent;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tposition: relative;\n\tpadding: 0.01px;\n\tflex-direction: column;\n\twidth: fit-content !important;\n\tmargin: 0 auto;\n"])));
var overrideModalBodyCSS = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-top: 6px;\n\toverflow: hidden;\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-top: 6px;\n\toverflow: hidden;\n"])));
var extraModalFadeInCSSStyles = css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tdisplay: flex;\n\talign-items: center;\n"], ["\n\tdisplay: flex;\n\talign-items: center;\n"])));
export var FeaturedQuizModal = function (_a) {
    var openButtonElement = _a.openButtonElement, onOpen = _a.onOpen, onClose = _a.onClose, quizImpression = _a.quizImpression, shouldAutoOpen = _a.shouldAutoOpen, props = __rest(_a, ["openButtonElement", "onOpen", "onClose", "quizImpression", "shouldAutoOpen"]);
    return (React.createElement(React.Fragment, null,
        React.createElement(GenericModal, { overrideModalCSSStyles: overrideModalCSS, overrideModalBodyCSSStyles: overrideModalBodyCSS, openButtonElement: openButtonElement, closeButtonPlacement: ModalCloseButtonPlacement.AboveModalBody, modalCloseElement: React.createElement(QuizModalCloseButton, null), extraModalFadeInCSSStyles: extraModalFadeInCSSStyles, disableHeaderElement: true, onOpen: onOpen, onClose: function () {
                if (typeof onClose === 'function') {
                    onClose();
                }
                store.dispatch(resetQuiz());
            }, modalImpression: quizImpression, shouldAutoOpen: shouldAutoOpen },
            React.createElement(Suspense, { fallback: React.createElement(Spinner, { size: 24 }) },
                React.createElement(QuizConsumption, __assign({}, props, { questionTimer: 20, initialQuestionIndex: 0 }))))));
};
var templateObject_1, templateObject_2, templateObject_3;
